import { Box, Text, VStack } from '@gluestack-ui/themed';
import React from 'react';
import { Pressable } from 'react-native';
import { COLORS } from '../theme/colors';

interface IErrorBoundaryProps {
  children: React.ReactNode;
}

interface IErrorBoundaryState {
  hasError: boolean;
}

// Catches render errors in the tree below it so a single bad component shows a
// friendly "reload" message instead of blanking the whole app (white screen).
export class ErrorBoundary extends React.Component<IErrorBoundaryProps, IErrorBoundaryState> {
  state: IErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): IErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: unknown, info: unknown) {
    // Surface it in the console for debugging; swallow it for the UI.
    console.error('[ErrorBoundary] caught render error:', error, info);
  }

  private reload = () => {
    if (typeof window !== 'undefined' && window.location) {
      window.location.reload();
    } else {
      this.setState({ hasError: false });
    }
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <Box style={{ flex: 1, alignItems: 'center', justifyContent: 'center', padding: 40, backgroundColor: COLORS.FOUNDATION_PRIMARY }}>
        <VStack gap={12} style={{ alignItems: 'center', maxWidth: 420 }}>
          <Text fontWeight="bold" fontSize={18} style={{ textAlign: 'center' }}>
            Une erreur s'est produite
          </Text>
          <Text fontSize={14} color={COLORS.NEUTRAL[90]} style={{ textAlign: 'center' }}>
            Un problème est survenu à l'affichage de cette page. Rechargez pour réessayer.
          </Text>
          <Pressable
            onPress={this.reload}
            style={{ marginTop: 8, backgroundColor: COLORS.ACCENT[100], borderRadius: 10, paddingVertical: 10, paddingHorizontal: 24 }}
          >
            <Text fontWeight="bold" color={COLORS.NEUTRAL[0]}>Recharger</Text>
          </Pressable>
        </VStack>
      </Box>
    );
  }
}
